import React, { Children, cloneElement, isValidElement } from 'react';
import { useIntl } from 'react-intl';
import { OverflowIcon } from '@panwds/icons';
import { breadcrumbOverflowLength, breadcrumbOverflowEnd } from '../../utils/constants.esm.js';
import { Button } from '../Button/Button.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Select } from '../Select/Select.esm.js';
import '@headlessui/react';
import { Body } from '../Typography/Body.esm.js';
import 'downshift';
import 'react-dom';
import '../Input/Input.esm.js';
import 'react-virtual';
import '../List/List.esm.js';
import '../List/ListItem.esm.js';
import 'uuid';

function canClone(arg) {
    return isValidElement(arg);
}
function Breadcrumbs({ children, dataMetrics, dataTestId, disabled = false, }) {
    const childArray = Children.toArray(children);
    const count = Children.count(children);
    const intl = useIntl();
    const overflowBreadcrumb = () => {
        const root = [], overflow = [], leftOver = [];
        childArray.map((child, index) => {
            if (canClone(child)) {
                if (index === 0) {
                    root.push(cloneElement(child, { disabled }));
                }
                else if (index >= count - breadcrumbOverflowEnd) {
                    leftOver.push(cloneElement(child, { disabled }));
                }
                else {
                    overflow.push({
                        value: "",
                        children: cloneElement(child, { isSelectItem: true }),
                        key: index,
                    });
                }
            }
        });
        return (React.createElement(React.Fragment, null,
            root,
            React.createElement(Select, { button: React.createElement(Button, { "aria-label": intl.formatMessage({ id: "wWAf4k", defaultMessage: [{ type: 0, value: "Overflow Button" }] }), icon: React.createElement(OverflowIcon, { size: "sm" }), appearance: "clear", size: "sm" }), disabled: disabled, items: overflow }),
            React.createElement(Body, { "aria-hidden": true, size: "sm", addClassName: "dark:tw-text-gray-100" }, "/"),
            leftOver));
    };
    if (!children)
        return null;
    return (React.createElement("nav", { "aria-label": intl.formatMessage({ id: "JMldRC", defaultMessage: [{ type: 0, value: "Breadcrumb navigation" }] }), "data-metrics": dataMetrics, "data-testid": dataTestId || "breadcrumb", className: "tw-font-lato tw-flex" },
        React.createElement("ul", { className: "tw-flex tw-flex-row tw-list-none tw-gap-1 tw-pl-0 tw-items-center" }, count > breadcrumbOverflowLength ? overflowBreadcrumb() : children)));
}

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.esm.js.map
